import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useSearchParams } from 'react-router-dom'

import {
	Button,
	Input,
	ModalBase,
	PageTransition,
	Icon,
	Title,
	Paragraph,
} from '@components/atoms'
import { SliderLogin } from '@components/molecules'
import { yupResolver } from '@hookform/resolvers/yup'
import { loginStyles } from '@pages/Login/styles'
import { recoveryEmailSchema } from '@schemas/auth/login.schema'
import { authApi } from '@services/AuthApi'

const { background, container } = loginStyles

type FormValues = {
	email: string
}

export default function RecoveryEmail() {
	const {
		register,
		handleSubmit,
		setError,
		formState: { errors },
	} = useForm<FormValues>({ resolver: yupResolver(recoveryEmailSchema) })

	const [openModal, setOpenModal] = useState(false)

	const [searchParams] = useSearchParams()

	const [recovery, { isLoading, isSuccess, data, error }] =
		authApi.useRecoveryMutation()

	const onSubmit = handleSubmit((payload) => {
		recovery(payload)
	})

	useEffect(() => {
		if (error) {
			setError('email', {
				type: 'manual',
				message: 'Ops! Email não encontrado, tente novamente.',
			})
		}
	}, [error, setError])

	useEffect(() => {
		if (isSuccess && data) {
			setOpenModal(true)
		}
	}, [isSuccess, data, setOpenModal])

	return (
		<PageTransition>
			<main className={background()}>
				<div className={container()}>
					<ModalBase title='Importante!' open={openModal}>
						<div style={{ marginTop: '32px' }}>
							<Title variant='h5' color='$neutral120'>
								{searchParams.get('new')
									? 'Enviamos para seu email um link de confirmação.'
									: 'Enviamos para seu email um link de confirmação para resetar sua senha.'}
							</Title>
							<Paragraph
								paragraphType='p2'
								css={{ color: '$neutral90', marginTop: '24px' }}
							>
								Obs.: Alguns emails podem entrar como spam, por isso verifique
								sua caixa de spam também!
							</Paragraph>
							<Button
								onClick={() => {
									setOpenModal(false)
								}}
								css={{ marginTop: '24px' }}
							>
								Ok
							</Button>
						</div>
					</ModalBase>
					<Link to='/'>
						<Icon title='logo DLS' name='logo' width={116} height={50} />
					</Link>

					<div className='titles'>
						<h4>
							{searchParams.get('new')
								? 'Primeiro acesso'
								: 'Esqueceu a senha?'}
						</h4>
						<p>
							{searchParams.get('new')
								? 'Digite seu email para receber as instruções de primeiro acesso.'
								: 'Insira seu email abaixo para refaze-la.'}
						</p>
					</div>

					<form onSubmit={onSubmit}>
						<Input
							placeholder='Email'
							error={errors.email?.message}
							{...register('email')}
						/>

						<Button
							onClick={onSubmit}
							loading={isLoading}
							css={{ marginTop: '88px !important', marginBottom: '154px' }}
						>
							Enviar
						</Button>
					</form>

					<Link className='link' to='/login'>
						Me lembrei!
					</Link>

					<h5>
						Não tem cadastro aqui?{' '}
						<Link className='link' to='/cadastre-se'>
							Cadastre-se!
						</Link>
					</h5>
				</div>

				<SliderLogin />
			</main>
		</PageTransition>
	)
}
